// <template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Course Record</div>
          <div class="line" />
        </div>
      </div>
      <div class="row-card-title right">
        <div class="custom-button-view-all" @click="goToCourseManagement()">
          <div class="card-titile-view-all">VIEW ALL</div>
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow alignHorizontal="between" class="row-header">
            <CRow>
              <CDropdown
                :toggler-text="sortBy"
                placement="right-start"
                addTogglerClasses="customDropDownColor"
              >
                <CDropdownItem @click="checkSortText('Sort by Newest')">Newest</CDropdownItem>
                <CDropdownItem @click="checkSortText('Sort by Name')">Name</CDropdownItem>
                <CDropdownItem @click="checkSortText('Sort by Online User')">Online User</CDropdownItem>
                <CDropdownItem @click="checkSortText('Sort by Enrolled User')">Enrolled User</CDropdownItem>
                <CDropdownItem @click="checkSortText('Sort by Complete')">Complete</CDropdownItem>
                <CDropdownItem @click="checkSortText('Sort by Posted')">Posted</CDropdownItem>
                <CDropdownItem @click="checkSortText('Sort by Sharing')">Sharing</CDropdownItem>
                <CDropdownItem @click="checkSortText('Sort by Income')">Income</CDropdownItem>
              </CDropdown>
              <div style="margin-left:  0.125rem; margin-right:  0.125rem" />
              <component :is="orderOption(sortBy)" />
            </CRow>
            <div>
              <div class="input-group">
                <input placeholder="SEARCH" class="custom-input" v-model.lazy="search" />
                <div style="cursor: pointer;">
                  <img src="@/assets/images/admin/Search.svg" class="icon" />
                </div>
              </div>
            </div>
          </CRow>
          <CRow>
            <template v-for="course in courses">
              <courseCardOverview :key="course._id" :course="course" />
            </template>
          </CRow>
        </CContainer>
      </div>
    </CRow>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex";
import sortingCourse from "../dropdown/sortingCourse";
import courseCardOverview from "../card/courseCardOverview";
import alphabeticalOrder from "../dropdown/alphabeticalOrder";
import amountOrder from "../dropdown/amountOrder";

export default {
  name: "CourseRecord",
  components: {
    sortingCourse,
    courseCardOverview,
    alphabeticalOrder,
    amountOrder
  },
  data() {
    return {
      search: "",
      courses: [],
      sortBy: "Sort by Newest"
    };
  },
  mounted() {
    this.fetchAllcourseData();
  },
  computed: {
    // ...mapGetters(["allCourseGetter"]),
    ...mapGetters(["allCourseTestGetter"])
  },
  watch: {
    // allCourseGetter: function(val) {
    //   this.setCourse(val);
    // },
    search: function(value) {
    },
    allCourseTestGetter: function(val) {
      this.setCourse(val);
    }
  },
  methods: {
    fetchAllcourseData() {
      // this.$store.dispatch("AllCourseDataAction");
      this.$store.dispatch("AllCourseDataAction2");
    },
    checkSortText(sortText) {
      if (sortText == "Sort by Newest") {
        this.sortBy = "Sort by Newest";
        alert(
          "Cant sort by date , api doesn't provide now // Updated 22 June 9:35 AM"
        );
        // this.sortingByDate();
      } else if (sortText == "Sort by Name") {
        this.sortBy = "Sort by Name";
        this.sortingByName();
      } else if (sortText == "Sort by Online User") {
        this.sortBy = "Sort by User";
        alert(
          "Cant sort by Online User , api doesn't provide now // Updated 22 June 9:35 AM"
        );
        // this.sortingByOnlineUser();
      } else if (sortText == "Sort by Enrolled User") {
        this.sortBy = "Sort by Enrolled User";
        alert(
          "Cant sort by Enrolled User , api doesn't provide now // Updated 22 June 9:35 AM"
        );

        // this.sortingByEnrolledUser();
      } else if (sortText == "Sort by Complete") {
        this.sortBy = "Sort by Complete";
        alert(
          "Cant sort by Complete , api doesn't provide now // Updated 22 June 9:35 AM"
        );

        // this.sortingByCompleteNumber();
      } else if (sortText == "Sort by Posted") {
        this.sortBy = "Sort by Posted";
        //this.sortingByPostedNumber();
        alert(
          "Cant sort by Posted , api doesn't provide now // Updated 22 June 9:35 AM"
        );
      } else if (sortText == "Sort by Sharing") {
        this.sortBy = "Sort by Sharing";
        //this.sortingBySharingNumber();
        alert(
          "Cant sort by Sharing , api doesn't provide now // Updated 22 June 9:35 AM"
        );
      } else if (sortText == "Sort by Income") {
        this.sortBy = "Sort by Income";
        //this.sortingByIncomeNumber();
        alert(
          "Cant sort by Income , api doesn't provide now // Updated 22 June 9:35 AM"
        );
      }
    },
    sortingByDate() {
      let courseHolder = this.courses;

      courseHolder.sort(function(a, b) {
        var dateA = new Date(a.date),
          dateB = new Date(b.date);
        return dateA - dateB;
      });
      this.setCourse(courseHolder);
    },
    sortingByName() {
      let courseHolder = this.courses;
      courseHolder.sort(function(a, b) {
        var titleA = a.name[0].val.toLowerCase(),
          titleB = b.name[0].val.toLowerCase();
        if (titleA < titleB) return -1;
        if (titleA > titleB) return 1;
        return 0;
      });
      // this.setCourse(courseHolder);
    },
    sortingByOnlineUser() {
      let courseHolder = this.courses;
      courseHolder.sort(function(a, b) {
        return a.online - b.online;
      });
      this.setCourse(courseHolder);
    },
    sortingByEnrolledUser() {
      let courseHolder = this.courses;
      courseHolder.sort(function(a, b) {
        return a.enrolled - b.enrolled;
      });
      this.setCourse(courseHolder);
    },
    sortingByCompleteNumber() {
      let courseHolder = this.courses;
      courseHolder.sort(function(a, b) {
        return a.complete - b.complete;
      });
      this.setCourse(courseHolder);
    },
    sortingByPostedNumber() {
      let courseHolder = this.courses;
      courseHolder.sort(function(a, b) {
        return a.post - b.post;
      });
      this.setCourse(courseHolder);
    },
    sortingBySharingNumber() {
      let courseHolder = this.courses;
      courseHolder.sort(function(a, b) {
        return a.sharing - b.sharing;
      });
      this.setCourse(courseHolder);
    },
    sortingByIncomeNumber() {
      let courseHolder = this.courses;
      courseHolder.sort(function(a, b) {
        return a.income - b.income;
      });
      this.setCourse(courseHolder);
    },
    setCourse(data) {
      this.courses = [];
      for (let i = 0; i < 4; i++) {
        this.courses.push(data.data[i]);
      }
    },
    goToCourseManagement() {
      this.$router.push("/course-management/courses-overview");
    },
    orderOption(sortBy) {
      if (sortBy === "Sort by Newest") {
        return null;
      } else if (sortBy === "Sort by Name") {
        return "alphabeticalOrder";
      } else {
        return "amountOrder";
      }
    }
  }
};
</script>
